export { default } from './SideMenuLayout';
export type { SideMenuLayoutProps } from './SideMenuLayout';
// The rail and its menu types are shared now — re-exported so existing importers,
// which are this brand's Institutional and Account layouts, keep working.
export type { SideMenuGroup, SideMenuItem } from '@v2/shared/Layouts/SideMenu';
